import { Dispatch } from 'redux';
import { AppState } from '../types/app-state';
import { Action } from '../types/action';
import { overallSummary } from '../services/reports';
import { OverallSummaryResponse } from '../types/overallsummary-response';
import * as Constants from './overallsummary.constants';

export interface UpdateQueryAction extends Action {
  month: number;
  year: number;
}

export interface ReportLoadedAction extends Action {
  data: OverallSummaryResponse[];
}

export function Initialize() {
  return async (dispatch: Dispatch<any>) => {
    dispatch({ type: Constants.INITIALIZE });
  };
}

export function Destroy() {
  return async (dispatch: Dispatch<any>) => {
    dispatch({ type: Constants.DESTROY });
  };
}

export function UpdateQuery(month?: number, year?: number) {
  return async (dispatch: Dispatch<any>, getState: () => AppState) => {
    try {
      const { auth, overallsummary } = getState();
      const { token } = auth;
      const { month: prevM, year: prevY } = overallsummary;

      if (typeof month !== 'number' && typeof prevM === 'number') {
        month = prevM;
      }

      if (typeof year !== 'number' && typeof prevY === 'number') {
        year = prevY;
      }

      dispatch({ type: Constants.UPDATE_QUERY, month, year });

      if (token) {
        const { status, data, message } = await overallSummary(token, month!, year!);
        if (status === 1 && data) {
          dispatch(ReportLoaded(data));
        } else {
          throw new Error(status === -2 ? 'A server error occurred' : message);
        }
      } else {
        throw new Error('User not authenticated');
      }

    } catch (error) {
      // dispatch(SetErrorMessage(error.message));
    }
  };
}

export function ReportLoaded(data: OverallSummaryResponse[]) {
  return {
    type: Constants.REPORT_LOADED,
    data
  };
}

export type All
  = Action
  | UpdateQueryAction
  | ReportLoadedAction;